import OverrideMenu from './OverrideMenu';

export default OverrideMenu;
